<template>
  <div class="wrapper">
    <div class="head">
      <div class="titleLeft">
        <img src="../../assets/images/titleArrow.png" @click="goBack" />
        <div class="label"></div>
      </div>
      <div class="titleRight">
        <img src="../../assets/images/cardIcon.png" alt="" @click="cardClick" />
      </div>
    </div>

    <div id="contain">
      <ul class="homework" v-if="topicList.length > 0">
        <li
          class="homeLi"
          v-show="topicList[currentIndex]"
          @touchstart="onTouchStart"
          @touchmove="onTouchMove"
          @touchend="onTouchEnd"
        >
          <div class="homework-main">
            <div>
              <span class="title">{{ topicList[currentIndex].typeName }}</span>
            </div>
            <div
              class="publicContent"
              v-if="
                topicList[currentIndex] && topicList[currentIndex].publicContent
              "
            >
              {{ topicList[currentIndex].publicContent }}
            </div>
            <ul
              class="publicSelect"
              v-if="
                topicList[currentIndex] && topicList[currentIndex].type == 4
              "
            >
              <li
                v-for="(itm, idx) in topicList[currentIndex].selectList"
                :key="idx"
              >
                <span>{{ itm.type }}.</span>{{ itm.name }}
              </li>
            </ul>
            <div class="content">
              {{ currentIndex + 1 }}.{{
                topicList[currentIndex] ? topicList[currentIndex].content : ""
              }}
            </div>
            <ul
              class="select"
              v-if="
                topicList[currentIndex] && topicList[currentIndex].selectList
              "
            >
              <li
                v-for="(itm, idx) in topicList[currentIndex].selectList"
                :key="idx"
              >
                <span
                  :class="getOptionClass(topicList[currentIndex], itm.type)"
                  @click="
                    canSelectOption(topicList[currentIndex])
                      ? handleSelect(topicList[currentIndex], itm, currentIndex)
                      : null
                  "
                  :style="
                    canSelectOption(topicList[currentIndex])
                      ? ''
                      : 'pointer-events: none; user-select: none;'
                  "
                  >{{ itm.type }}</span
                >
                <div>
                  {{ topicList[currentIndex].type == 4 ? itm.type : itm.name }}
                </div>
              </li>
            </ul>

            <div
              class="correctAnswerBox"
              v-if="
                topicList[currentIndex].analysis &&
                ((isStudy == 1 && isStudents) || !isStudents)
              "
            >
              <!-- <div class="selectAnswer">
                正确答案是"<span>{{ topicList[currentIndex].correct }}</span
                >",您的答案是"<span>{{ topicList[currentIndex].result }}</span
                >"
              </div> -->
              <!-- <div class="correct">
                {{ topicList[currentIndex].correct }}
              </div> -->
              <div class="correctAnswer"><span></span>试题详解</div>
              <div class="correct">
                {{ topicList[currentIndex].analysis }}
              </div>
            </div>

            <!-- 最后一题显示提交按钮 -->
            <div
              class="submit-bottom"
              v-if="
                currentIndex === topicList.length - 1 &&
                isStudy == 0 &&
                isStudents
              "
            >
              <div class="submit-btn" @click="submitAll">提交答案</div>
            </div>
          </div>
        </li>
      </ul>

      <van-popup v-model="cardFlag" position="bottom" round class="card">
        <div class="cardTitle">答题卡</div>
        <ul class="cardUl">
          <li
            v-for="(item, index) in topicList"
            :key="index"
            @click="switchTopic(index)"
            :class="getCardClass(index)"
          >
            {{ index + 1 }}
          </li>
        </ul>
      </van-popup>
    </div>
  </div>
</template>

<script>
import {
  myAnswerSheet,
  submitOnlineCourse,
  myAnswerSheetls,
  submitTeachingPlanPaperRecord,
} from "@/api/courseTopic/index.js";
import { getDicts } from "@/api/system/dict/data";

export default {
  data() {
    return {
      isStudy: "",
      isStudents: "",
      onlineCourseId: "",
      onlineCourseResourceId: "",
      paperId: "",
      typeData: [],
      topicList: [],
      cardFlag: false,
      currentIndex: 0, // 当前题目索引
      // 触摸相关数据
      touchStartX: 0,
      touchStartY: 0,
      touchEndX: 0,
      touchEndY: 0,
      minSwipeDistance: 50, // 最小滑动距离
      paperStatus: "",
      queryType: "",
      planDetailId: "",
      userId: "",
    };
  },
  computed: {
    answeredCount() {
      return this.topicList.filter((item) => {
        if (item.questionType === 5) {
          // X型题：检查数组是否有内容
          return item.answer && item.answer.length > 0;
        } else {
          // 普通题：检查是否有答案
          return item.answer !== null && item.answer !== undefined;
        }
      }).length;
    },
  },
  created() {
    if (this.$route.query.type == 1) {
      this.isStudy = this.$route.query.isStudy;
      this.isStudents = this.$route.query.isStudents;
      this.onlineCourseId = this.$route.query.onlineCourseId;
      this.onlineCourseResourceId = this.$route.query.onlineCourseResourceId;
      this.paperId = this.$route.query.paperId;
      this.getDict();
      this.getMyAnswerSheet();
    } else if (this.$route.query.type == 2) {
      this.queryType = this.$route.query.queryType;
      this.paperStatus = this.$route.query.paperStatus;
      this.planDetailId = this.$route.query.planDetailId;
      this.paperId = this.$route.query.paperId;
      this.userId = this.$route.query.userId;

      // 新增兼容逻辑
      if (this.queryType == 0) {
        // 学生
        this.isStudents = true;
        this.isStudy = this.paperStatus == 1 ? 1 : 0;
      } else if (this.queryType == 1) {
        // 老师
        this.isStudents = false;
        this.isStudy = 1; // 老师默认只能查看
      }

      this.getPlanUserAnswerSheetDetail();
    } 
    // else {
    //   this.queryType = this.$route.query.queryType;
    //   this.paperStatus = this.$route.query.paperStatus;
    //   this.planDetailId = this.$route.query.planDetailId;
    //   this.paperId = this.$route.query.paperId;
    //   this.getPlanUserAnswerSheetDetail();
    // }
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getDict() {
      getDicts("cmtt_exam_type").then((res) => {
        this.typeData = res.data;
      });
    },
    async getPlanUserAnswerSheetDetail() {
      const setList = {
        planDetailId: this.planDetailId,
        paperId: this.paperId,
        userId: this.userId,
      };
      const { data } = await myAnswerSheetls(setList);
      this.topicList = data;

      // 初始化每个题目的answer字段
      this.topicList.forEach((item) => {
        if (item.questionType === 5) {
          // X型题：初始化为数组
          if (!item.answer) {
            item.answer = [];
          } else if (typeof item.answer === "string") {
            // 如果是字符串，转换为数组
            item.answer = item.answer ? item.answer.split(",") : [];
          }
        } else {
          // 其他题型：初始化为null
          if (!item.answer) {
            item.answer = null;
          }
        }
      });
    },
    async getMyAnswerSheet() {
      const setList = {
        onlineCourseId: this.onlineCourseId,
        onlineCourseResourceId: this.onlineCourseResourceId,
        paperId: this.paperId,
      };
      const { data } = await myAnswerSheet(setList);
      this.topicList = data;

      // 初始化每个题目的answer字段
      this.topicList.forEach((item) => {
        if (item.questionType === 5) {
          // X型题：初始化为数组
          if (!item.answer) {
            item.answer = [];
          } else if (typeof item.answer === "string") {
            // 如果是字符串，转换为数组
            item.answer = item.answer ? item.answer.split(",") : [];
          }
        } else {
          // 其他题型：初始化为null
          if (!item.answer) {
            item.answer = null;
          }
        }
      });
    },

    // 触摸开始
    onTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
    },

    // 触摸移动
    onTouchMove(event) {
      // 阻止默认行为，防止页面滚动
      // event.preventDefault();
    },

    // 触摸结束
    onTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      this.touchEndY = event.changedTouches[0].clientY;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;

      // 判断是否为有效的水平滑动（水平滑动距离大于垂直滑动距离）
      if (
        Math.abs(deltaX) > Math.abs(deltaY) &&
        Math.abs(deltaX) > this.minSwipeDistance
      ) {
        if (deltaX > 0) {
          // 向右滑动 - 上一题
          this.prevTopic();
        } else {
          // 向左滑动 - 下一题
          this.nextTopic();
        }
      }
    },

    // 上一题
    prevTopic() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },

    // 下一题
    nextTopic() {
      if (this.currentIndex < this.topicList.length - 1) {
        this.currentIndex++;
      }
    },

    cardClick() {
      this.cardFlag = !this.cardFlag;
    },
    // 切换题目
    switchTopic(index) {
      this.currentIndex = index;
      this.cardFlag = false; // 关闭答题卡
    },
    // 获取答题卡样式类
    getCardClass(index) {
      const item = this.topicList[index];
      const isTeacher = !this.isStudents;
      const isStudentDone = this.isStudents && this.isStudy == 1;

      if (isTeacher || isStudentDone) {
        // 老师或学生已做完，按isRight显示
        return {
          active: index === this.currentIndex,
          red: item && item.isRight === 0,
          green: item && item.isRight === 1,
        };
      } else {
        // 学生未做完，按是否有答案高亮
        let hasAnswer = false;
        if (item && item.answer !== null && item.answer !== undefined) {
          if (item.questionType === 5) {
            hasAnswer = Array.isArray(item.answer) && item.answer.length > 0;
          } else {
            hasAnswer =
              item.answer !== null &&
              item.answer !== undefined &&
              item.answer !== "";
          }
        }
        return {
          active: index === this.currentIndex,
          green: hasAnswer,
        };
      }
    },

    // 选择处理
    handleSelect(item, option, index) {
      console.log("选择了:", option);
      console.log(
        "题目类型:",
        item.type,
        "题目类型名:",
        item.typeName,
        "questionType:",
        item.questionType
      );

      // 处理X型题（多选）和普通题（单选）
      if (item.questionType === 5) {
        // X型题：多选逻辑
        if (!item.answer) {
          item.answer = [];
        }
        const optionIndex = item.answer.indexOf(option.type);
        if (optionIndex > -1) {
          // 如果已选中，则取消选中
          item.answer.splice(optionIndex, 1);
          console.log("取消选中:", option.type, "当前答案:", item.answer);
        } else {
          // 如果未选中，则添加选中
          item.answer.push(option.type);
          console.log("选中:", option.type, "当前答案:", item.answer);
        }
      } else {
        // 普通题：单选逻辑
        item.answer = option.type;
        console.log("单选答案:", item.answer);
      }

      // 强制更新视图
      this.$forceUpdate();
    },

    // 判断选项是否被选中
    isOptionSelected(item, optionType) {
      if (!item || !item.answer) return false;

      if (item.questionType === 5) {
        // X型题：检查数组中是否包含该选项
        return Array.isArray(item.answer) && item.answer.includes(optionType);
      } else {
        // 普通题：直接比较
        return item.answer === optionType;
      }
    },

    // 判断是否可点击选项
    canSelectOption(item) {
      // 只有学生且isStudy==0时可点击
      return this.isStudents && this.isStudy == 0;
    },

    // 获取选项样式类（用于移动端的选中状态显示）
    getOptionClass(item, optionType) {
      const isTeacher = !this.isStudents;
      const isStudentDone = this.isStudents && this.isStudy == 1;
      const isAnswerMode = this.isStudents && this.isStudy == 0;

      if (isTeacher || isStudentDone) {
        // 查看模式：显示正确答案和错误选择
        const isSelected = this.isOptionSelected(item, optionType);
        let isCorrect = false;
        if (item.questionType === 5) {
          const correctAnswers = item.correct ? item.correct.split(",") : [];
          isCorrect = correctAnswers.includes(optionType);
        } else {
          isCorrect = item.correct === optionType;
        }
        return {
          green: isCorrect, // 正确答案绿色
          red: isSelected && !isCorrect, // 选错红色
        };
      } else if (isAnswerMode) {
        // 答题模式：只显示选中状态
        return {
          selected: this.isOptionSelected(item, optionType),
        };
      }
    },

    // 提交答案
    submit(item, index) {
      console.log("提交答案:", item);
    },

    // 绑定样式类（保持原有方法名，用于显示答案解析时的样式）
    bindClass(optionType, correct, result) {
      if (correct === optionType) {
        return "green"; // 正确答案
      } else if (result === optionType) {
        return "red"; // 错误的选择
      }
      return "grey"; // 其他选项
    },

    // 提交所有答案
    submitAll() {
      // 处理提交数据，将X型题的多选答案数组转换为字符串
      const processedTopicList = this.topicList.map((item) => {
        const processedItem = { ...item };

        if (item.questionType === 5 && Array.isArray(item.answer)) {
          // X型题：将答案数组转换为逗号分隔的字符串
          processedItem.answer = item.answer.join(",");
        }

        return processedItem;
      });

      // 根据 type 判断使用不同的提交接口
      if (this.$route.query.type == 1) {
        // type == 1 使用原有接口
        const setList = {
          onlineCourseId: this.onlineCourseId,
          onlineCourseResourceId: this.onlineCourseResourceId,
          paperId: this.paperId,
          questionResults: processedTopicList,
        };

        submitOnlineCourse(setList).then((res) => {
          if (res.code == 200) {
            this.$message.success("提交成功");
            this.$router.go(-1);
          }
        });
      } else if (this.$route.query.type == 2) {
        // type == 2 使用新接口
        const setList = {
          planDetailId: this.planDetailId,
          paperId: this.paperId,
          questionResults: processedTopicList,
        };

        submitTeachingPlanPaperRecord(setList).then((res) => {
          if (res.code == 200) {
            this.$message.success("提交成功");
            this.$router.go(-1);
          }
        });
      }

      // this.$confirm("确定要提交答案吗？提交后将无法修改。", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {

      //   })
      //   .catch(() => {
      //     // 取消提交
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
.notBox {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(225deg, #cbeaff 0%, #d9e2ff 100%);

  .loadingCircle {
    position: relative;
    width: 300px;
    height: 300px;
    .circle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background-color: #a8dafc;
      animation: pulse 2s infinite;
    }
    .loading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 171px;
      height: 200px;
    }
  }
  span {
    margin-top: 99px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #0a1f33;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }

  @keyframes pulse {
    0% {
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      width: 300px;
      height: 300px;
      opacity: 0;
    }
  }

  .circle:nth-child(2) {
    animation-delay: 0.5s;
  }

  .circle:nth-child(3) {
    animation-delay: 1s;
  }
}
.wrapper {
  width: 100%;
  height: 100vh;
  .head {
    padding: 44px 16px 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .titleLeft {
      display: flex;
      // width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      img {
        width: 20px;
        height: 20px;
      }
      .label {
        font-weight: 600;
        font-size: 16px;
      }
    }
    .titleRight {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // max-width: 149px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      // border-radius: 50%;
      // background: rgba(27, 191, 141, 0.1);
      div {
        margin-right: 10px;
        width: 28px;
        height: 28px;
      }
      img {
        margin-right: 10px;
        width: 28px;
        height: 28px;
        line-height: 28px;
        &:last-child {
          margin-right: 6px;
        }
      }
    }
  }
  #contain {
    width: 100vw;
    height: calc(100vh - 88px);
    overflow: hidden;
    .homework {
      height: 100%; // 修改：移除固定高度
      // display: flex; // 修改：移除 flex 布局
      li {
        list-style: none;
        height: 100%;
        width: 100%; // 修改：修改宽度为 100%
        // flex-shrink: 0; // 修改：移除 flex-shrink
        font-size: 16px;
        &.homeLi {
          padding: 12px 16px;
          display: flex;
          flex-direction: column;
          overflow-x: hidden;

          .homework-main {
            flex: 1;
            overflow-y: scroll;
            &::-webkit-scrollbar {
              display: none;
            }
            &.active {
              display: flex;
              flex-direction: column;
              .title {
              }
            }
          }
        }
        .title {
          // display: flex;
          // justify-content: center;
          // align-items: center;
          padding: 5px;
          height: 18px;
          line-height: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #00ad78;
          background: rgba(27, 191, 141, 0.16);
        }
        .publicContent {
          margin-top: 10px;
          line-height: 24px;
          font-size: 14px;
        }
        .content {
          font-family: PingFangSC, PingFang SC;
          margin-top: 10px;
          font-weight: 500;
          line-height: 30px;
          color: #000;
        }
        .file {
          display: flex;
          justify-content: center;
          width: 100%;
          .imgBox {
            width: 300px;
            height: 200px;
            background: #d8d8d8;
            border-radius: 10px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover; /* 等比例裁剪填充 */
            }
          }
          .videoBox {
            width: 300px;
            height: 200px;
            background: #d8d8d8;
            border-radius: 10px;
            overflow: hidden;
          }
          .audioBox {
            width: 310px;
            height: 106px;
            .progressBar {
              display: flex;
              align-items: center;
              gap: 10px;
              margin-bottom: 14px;
              width: 100%;
              height: 20px;
              input[type="range"] {
                width: 212px;
                height: 6px;
                background: #f2f8f5;
                border-radius: 3px;
                border: none; /* 去掉边框 */
                outline: none; /* 去掉选中时的外边框 */
                -webkit-appearance: none; /* 去掉默认样式（适用于 WebKit 浏览器，如 Chrome、Safari） */
              }
              /* 自定义滑块轨道样式 */
              input[type="range"]::-webkit-slider-runnable-track {
                width: 100%;
                height: 6px;
                // background: #1bbf8d;
                border-radius: 3px;
              }

              /* 自定义滑块按钮样式 */
              input[type="range"]::-webkit-slider-thumb {
                -webkit-appearance: none;
                width: 10px;
                height: 10px;
                background: #1bbf8d;
                border-radius: 50%;
                cursor: pointer;
                margin-top: -2px; /* 让滑块和轨道对齐 */
                box-shadow: 0 0 0 5px rgba(27, 191, 141, 0.1);
              }
              // /* 兼容 Firefox */
              // input[type="range"]::-moz-range-progress {
              //   background: #1bbf8d;
              // }
              // input[type="range"]::-moz-range-track {
              //   background: #f2f8f5;
              // }
            }
            .operateBox {
              position: relative;
              padding: 0 35px;
              width: 100%;
              height: 72px;
              .wave {
                position: absolute;
                top: 50%;
                width: 218px;
                height: 24px;
                transform: translateY(-50%);
                background-image: url("../../assets/images/wave.png");
                background-size: cover; /* 让背景图完全覆盖 */
                background-position: center; /* 让背景图居中 */
                background-repeat: no-repeat; /* 防止背景重复 */
              }
              .pause {
                position: absolute;
                left: 50%;
                transform: translateX(-60%);
                width: 72px;
                height: 72px;
                background-image: url("../../assets/images/pause.png");
                background-size: cover; /* 让背景图完全覆盖 */
                background-position: center; /* 让背景图居中 */
                background-repeat: no-repeat; /* 防止背景重复 */
              }
              .play {
                position: absolute;
                left: 50%;
                transform: translateX(-60%);
                width: 72px;
                height: 72px;
                background-image: url("../../assets/images/play.png");
                background-size: cover; /* 让背景图完全覆盖 */
                background-position: center; /* 让背景图居中 */
                background-repeat: no-repeat; /* 防止背景重复 */
              }
            }
          }
        }
        .publicSelect {
          li {
            display: flex;
            align-items: center;
            padding: 5px 0;
            width: calc(100vw - 32px);
          }
        }
        .select {
          li {
            display: flex;
            align-items: center;
            padding: 13px 0;
            width: 100%;
          }
          span {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 0 0 28px;
            width: 28px;
            height: 28px;
            border: 1px solid #dddddd;
            border-radius: 50%;
            color: #7f8d95;
            margin-right: 12px;
            &.selected {
              background: #1bbf8d;
              color: #fff;
            }
            &.borderGreen {
              border-color: #1bbf8d;
              color: #1bbf8d;
            }
            &.red {
              background: #fe4e27;
              color: #fff;
            }
            &.green {
              background: #1bbf8d;
              color: #fff;
            }
            &.grey {
              background: grey;
              color: #fff;
            }
          }
        }
        .blanksUl {
          padding: 0;
          margin-top: 24px;
          width: 100%;
          li {
            margin-bottom: 12px;
            width: 100%;
            list-style: none;
            textarea {
              padding: 9px 10px;
              width: 100%;
              height: 40px;
              // line-height: 36px;
              background: #f5f5f5;
              border-radius: 8px;
              font-size: 16px;
              outline: none; // 如何把蓝色去掉？
              border: 1px solid #f5f5f5; /* 初始化边框颜色为灰色 */
              resize: none; /* 禁止手动调整大小 */
              overflow-y: hidden; /* 隐藏垂直滚动条 */
              box-sizing: border-box; /* 防止padding和border增加实际宽度 */
            }
            textarea:focus {
              outline: none; // 如何把蓝色去掉？
              border: 1px solid #58b195; // 如何改成别的颜色？
            }

            // .focus-border {
            //   border-color: #58b195;
            // }
            // .focus-border {
            //   padding: 9px 10px;
            //   width: 100%;
            //   // height: 40px;
            //   background: #f5f5f5;
            //   border-radius: 8px;
            //   font-size: 16px;
            //   // outline: none; // 如何把蓝色去掉？
            //   border: 1px solid #f5f5f5; /* 初始化边框颜色为灰色 */
            //   resize: none; /* 禁止手动调整大小 */
            //   // overflow-y: hidden; /* 隐藏垂直滚动条 */
            //   box-sizing: border-box; /* 防止padding和border增加实际宽度 */
            //   &.focus-border {
            //     border-color: #58b195;
            //   }
            // }
          }
        }
        .correctAnswerBox {
          margin-top: 20px;
          .correctAnswer {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #222222;
            height: 24px;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            span {
              margin-right: 5px;
              width: 3px;
              height: 14px;
              background: #1bbf8d;
            }
          }
          .selectAnswer {
            font-size: 16px;
            margin-bottom: 24px;
            span {
              color: #1bbf8d;
            }
          }
          .correct {
            line-height: 28px;
            text-align: left;
          }
        }
        .correctAnswerUl {
          margin-top: 10px;
          .correctAnswerLi {
            margin-bottom: 4px;
            list-style: none;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }
        .upwardBtn {
          width: 100px;
          height: 100px;
        }
        .downBtn {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
  .askInput {
    border: 1px solid #dddddd;
    width: 100%;
    min-height: 100%;
    // height: auto;
    margin-top: 12px;
    margin-bottom: 20px;
    padding: 10px;
    // overflow: hidden;
    resize: none;
    // overscroll-behavior: contain;
  }
  .haveResult {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 10px;
  }

  .bottom {
    height: 86px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .btn {
      padding: 0px 24px;
      height: 48px;
      line-height: 48px;
      background: #1bbf8d;
      box-shadow: 0px 3px 10px 0px rgba(27, 191, 141, 0.3);
      border-radius: 24px;
      color: #fff;
      text-align: center;
      font-size: 16px;
      display: inline-block;
    }
  }

  .submit-bottom {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    .submit-btn {
      padding: 0px 20px;
      height: 40px;
      line-height: 40px;
      background: #1bbf8d;
      box-shadow: 0px 3px 10px 0px rgba(27, 191, 141, 0.3);
      border-radius: 20px;
      color: #fff;
      text-align: center;
      font-size: 14px;
      display: inline-block;
      cursor: pointer;
    }
  }
}

@keyframes cardUp {
  from {
    transform: translateY(100%); /* 从元素上方滑入 */
    opacity: 0; /* 初始透明度为0 */
  }
  to {
    transform: translateY(0);
    opacity: 1; /* 结束时完全不透明 */
  }
}
@keyframes cardDown {
  from {
    transform: translateY(0); /* 从元素上方滑入 */
    opacity: 1; /* 初始透明度为0 */
  }
  to {
    transform: translateY(100%);
    opacity: 0; /* 结束时完全不透明 */
  }
}

.card {
  padding: 8px 21px;
  position: absolute;
  bottom: 0; /* 初始状态在底部之外 */
  width: 100%;
  height: 50%;
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;
  backdrop-filter: blur(6px);
  .cardTitle {
    margin-top: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #2f2f46;
    text-align: center;
    font-style: normal;
  }
  .cardUl {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 0px 5px; /* 添加间距 */
    width: 100%;
    max-height: 60%;
    transition: max-height 0.5s ease-in-out;
    overflow-y: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
    li {
      margin-bottom: 10px;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #ffffff;
      border: 1px solid #dddddd;
      list-style: none;
      font-family: ArialMT;
      font-size: 13px;
      color: #8b949a;
      line-height: 28px;
      text-align: center;
      font-style: normal;
      &.red {
        background: #fe4e27;
        color: #fff;
      }
      &.green {
        background: #1bbf8d;
        color: #fff;
      }
      &.grey {
        background: grey;
        color: #fff;
      }
      &.prohibit {
        color: #cdd2d5;
      }
    }
    .active {
      background: #1bbf8d;
      color: #ffffff;
    }
  }
  .bottom {
    position: absolute;
    bottom: 0px;
    width: calc(100% - 42px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.collect {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 36px;
  background: rgba(51, 51, 51, 0.8);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  font-style: normal;
}
.cancelCollect {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 92px;
  height: 36px;
  background: rgba(51, 51, 51, 0.8);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  font-style: normal;
}

.noteBox {
  padding: 30px 16px 15px 16px;
  width: 100%;
  height: 80%;
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;
  backdrop-filter: blur(6px);
  h2 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #2f2f46;
    // line-height: 24px;
    text-align: center;
    font-style: normal;
  }
  .noteTextarea {
    margin-top: 16px;
    padding: 10px 16px;
    width: 100%;
    height: 352px;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    border-radius: 12px;
    border: 1px solid #eeeeee;
    background: #ffffff;
    overflow-x: hidden;
    overflow-y: scroll; /* 允许Y轴滚动 */
    // textarea {
    //   width: 100%; /* 确保textarea宽度自适应 */
    //   height: 100%; /* 高度自适应 */
    //   overflow-x: hidden; /* 隐藏X轴滚动条 */
    //   overflow-y: scroll; /* 允许Y轴滚动 */
    //   resize: none; /* 禁止手动调整大小 */
    //   box-sizing: border-box; /* 包含内边距和边框在内 */
    //   white-space: pre-wrap; /* 确保换行 */
    //   word-wrap: break-word; /* 遇到长单词换行 */
    // }
  }
  textarea:focus {
    outline: none; // 如何把蓝色去掉？
    border: 1px solid #58b195; // 如何改成别的颜色？
  }
  .noteBtnBox {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    width: 100%;
    .noteBtn {
      width: 140px;
      height: 48px;
      background: #1bbf8d;
      border-radius: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 48px;
      text-align: center;
      font-style: normal;
    }
  }
}
.setUpBox {
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 92px;
  right: 10px;
  width: 150px;
  height: 100px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(188, 190, 192, 0.4);
  border-radius: 8px;
  .setUpType {
    display: flex;
    padding: 2px;
    width: 100px;
    height: 28px;
    background: #f3f3f3;
    border-radius: 14px;
    div {
      width: 48px;
      height: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #bbbbbb;
      line-height: 24px;
      text-align: center;
      font-style: normal;
    }
    .active {
      background: #ffffff;
      border-radius: 12px;
      opacity: 1;
      color: #000;
    }
    .setUpType div:not(.active) {
      opacity: 0;
    }
  }
  .setUpFont {
    padding: 0 29px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #bbbbbb;
    text-align: left;
    font-style: normal;
    .active {
      color: #333333;
    }
    span:first-child {
      font-size: 14px;
    }
    span:nth-child(2) {
      font-size: 16px;
    }
    span:last-child {
      font-size: 20px;
    }
  }
}
</style>

